import { Injectable } from '@angular/core';

import { LoadingService } from '../../services/loading.service';

/**
 * Router AuthGuard for pages that required a logged in user
 */
@Injectable({
    providedIn: 'root'
})
export class ServerDownPageGuard  {

    constructor(private loadingService: LoadingService) { }

    canActivate(): boolean {
        this.loadingService.unsetMajorLoading();
        return true;
    }

}
